import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/evelynbardash/projects/accor/payments-checkout/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
